module.exports = __webpack_public_path__ + "img/calendar.1479b415.svg";